<template>
  <div>
    <v-dialog v-model="show" v-bind="$attrs">
      <v-card class="mx-auto">
        <v-img :src="url" maxHeight="250px" contain></v-img>

        <v-divider class="mt-3"></v-divider>
        <v-card-title>{{ $t("label.signback_image") }}</v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" small @click.stop="show = false">
            <v-icon>{{ mdiClose }}</v-icon
            >{{ $t("label.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <snackbar-msg
      v-model="snackBarMsg.show"
      :text="snackBarMsg.text"
      :color="snackBarMsg.color"
    ></snackbar-msg>
  </div>
</template>

<script>
import { mdiClose, mdiLineScan } from "@mdi/js";
import { GetSignBackImg, GetSignBackImg2 } from "@/api/publicServices";

export default {
  props: {
    value: Boolean,
    docType: {
      type: String,
      required: true,
    },
    docNo: {
      type: String,
      required: true,
    },
  },
  components: {
  },
  computed: {
    show: {
      get() {
        console.log(`ImageViewerDialog get ${this.value}`);
        if (this.value) {
          this.getSignBackImg2();
        }
        return this.value;
      },
      set(value) {
        console.log(`ImageViewerDialog Set ${value}`);
        this.$emit("input", value);
      },
    },
  },
  data: () => ({
    url: "",

    snackBarMsg: {
      show: false,
      text: "",
      color: "red",
    },

    //svg icons
    mdiClose,
    mdiLineScan,
  }),
  methods: {
    async getSignBackImg() {
      try {
        if (this.docType == "SIGNBACK") {
          let data = { BundleNo: this.docNo };
          this.url = require("../assets/no-image-icon.png");
          const response = await GetSignBackImg(data);
          if (response.data.length > 0) {
            this.url = `data:image/jpeg;base64,${response.data}`;
          }
        }
      } catch (error) {
        console.log(error);
        this.snackBarMsg.text = "Service Error";
        this.snackBarMsg.show = true;
      }
    },

    async getSignBackImg2() {
      try {
        if (this.docType == "SIGNBACK") {
          let path = `/${this.docNo}`;
          this.url = require("../assets/no-image-icon.png");
          const response = await GetSignBackImg2(path);
          console.log();
          if (response.data.size > 0) {
            this.url = URL.createObjectURL(response.data);
          }
        }
      } catch (error) {
        console.log(error);
        this.snackBarMsg.text = "Service Error";
        this.snackBarMsg.show = true;
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped></style>
